import { apiCall } from './gqlClient';
const GETBODYMEASUREMENTS_QUERY = "\n  query getBodyMeasurements($userId: Int!) {\n    getBodyMeasurements(userId: $userId)\n    {\n      id\n\t\t\tuserId\n\t\t\tleanMass\n\t\t\tboneMass\n\t\t\tvisceralFat\n\t\t\tleftBiceps\n\t\t\trightBiceps\n\t\t\tchest\n\t\t\twaist\n\t\t\thips\n\t\t\tleftLeg\n\t\t\trightLeg\n\t\t\tleftCalf\n\t\t\trightCalf\n\t\t\theight\n\t\t\tweight\n\t\t\tdateCreated\n      ...fragments\n    }\n  }";
export const getBodyMeasurementsApiCall = async function (_ref) {
  let {
    userId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GETBODYMEASUREMENTS_QUERY,
    variables: {
      userId
    },
    fragments
  });
};